let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9CDY0"), load("j2CBR"), load("6ZyhU"), load("1dyEV")]).then(() => parcelRequire('hMkTx'));